// function clearCart() {
//   fetch("/cart/clear?clear-cart-function", {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//   })
//     .then((response) => {
//       if (response.ok) {
//         console.log("Cart cleared successfully");
//         location.reload();
//       } else {
//         console.error("Failed to clear the cart");
//       }
//     })
//     .catch((error) => {
//       console.error("Error clearing the cart", error);
//     });
// }

// function childToParent(cart) {
//   let addonItems = cart.items.filter((item) => {
//     let item_properties = item.properties;
//     return item_properties && "_addon" in item_properties;
//   });

//   if (addonItems.length > 0) {
//     addonItems.forEach((addonItem) => {
//       let targetProduct = addonItem.properties["_main_product"];
//       let targetProductId = targetProduct.split(":")[0];
//       let targetTimeProperty = addonItem.properties["_time"];
//       let isProductInCart = cart.items.some((item) => {
//         let item_properties = item.properties;
//         if (item_properties && "_time" in item_properties) {
//           let mainProductID = item.product_id;
//           let timeProperty = item_properties["_time"];
//           return (
//             mainProductID == targetProductId &&
//             timeProperty == targetTimeProperty
//           );
//         }
//         return false;
//       });

//       if (!isProductInCart) {
//         console.log("Cart cleared successfully");
//         clearCart();
//       }
//     });
//   } else {
//     console.log("No item with _addon found in the cart.");
//   }
// }

// function parentToChild(result) {
//   let mainItem = result.items.filter((item) => {
//     let item_properties = item.properties;
//     return item_properties && "_kittt" in item_properties;
//   });

//   let addonItem = result.items.filter((item) => {
//     let item_properties = item.properties;
//     return item_properties && "_addon" in item_properties;
//   });

//   if (mainItem.length > 0) {
//     mainItem.forEach((parentItem) => {
//       let addonitemqty = parseInt(parentItem.properties["_varinat_size"]);
//       let targetTimeProperty = parentItem.properties["_time"];
//       let itemProperty = parentItem.properties;

//       const newArray = [];
//       for (const key in itemProperty) {
//         if (key.startsWith("_plus-")) {
//           let varientId = parseInt(itemProperty[key]);
//           newArray.push(varientId);
//         }
//       }
//       if (newArray.length == addonitemqty) {
//         let count = 0;
//         addonItem.forEach((addon) => {
//           let addonTime = addon.properties["_time"];
//           if (addonTime == targetTimeProperty) {
//             count++;
//           }
//         });
//         if (count != addonitemqty) {
//           console.log("clearCart()")
//           clearCart();
//         }
//       } else {
//         console.log("clearCart()")
//         clearCart();
//       }
//     });
//   }
// }

/*** Adds classes to the item of the Cart Drawer on refresh ****/
function last_border() {
  $(".mini-cart-list-item").each(function (i) {
    if (!$(this).hasClass("mini-cart--addon-line")) {
      $(this).addClass("mini-cart-kit-prev");
    }
  });
  $(".mini-cart-kit-prev")
    .prev(".mini-cart--addon-line")
    .addClass("mini-cart--addon-line-last");
}

function formatPrice(price) {
  // Assuming price is in cents, you might need to adjust the conversion based on your setup
  const priceInKr = price / 100; // Convert from cents to Krona
  return `${priceInKr.toFixed(0)} kr`; // Display the price without decimal places
}

/**** Custom Mini Cart ****/
// function cartBar(cartData) {
//   if (cartData === 0 || cartData == '' || cartData === undefined) {
//     jQuery.getJSON("/cart.js?cartBar", function (cart) {
//       var money = (cart.total_price / 100).toFixed(2);
//       var ic = cart.item_count;
//       var userValue = parseInt($(".custom-bar-text-unfill span").text());
//       var subTotal_cart = parseInt(money.replace("$", ""));
//       var result = (100 / userValue) * subTotal_cart;
//       var rrr = userValue - subTotal_cart;
//       $(".asd").text(rrr);
//       if (subTotal_cart >= userValue) {
//         result = 100;
//         $(".custom-bar-text-fill").show();
//         $(".custom-bar-text-unfill").hide();
//       } else {
//         $(".custom-bar-text-fill").hide();
//         $(".custom-bar-text-unfill").show();
//         $(".custom-bar-text-unfill span").hide();
//         $(".asd").show();
//       }
//       if (ic <= 0) {
//         result = 0;
//         $(".custom-bar-text-fill").hide();
//       }
//       if (cart.item_count > 0) {
//         $(".cart-quantity-2.cart-number").removeClass("icon-hide"); 
//       } else {
//         $(".cart-quantity-2.cart-number").addClass("icon-hide");
//       }
//       $(".custom-bar-range").css("width", "" + result + "%");
//       parentToChild(cart)
//       enableBundleFeature && cart_item_count(cart)
//       enableBundleFeature && slabHandle(cart);
//     });
//   } else {
//     var ic = cartData.item_count;
//     var money = (cartData.total_price / 100).toFixed(2);
//     var userValue = parseInt($(".custom-bar-text-unfill span").text());
//     var subTotal_cart = parseInt(money.replace("$", ""));
//     var result = (100 / userValue) * subTotal_cart;
//     var rrr = userValue - subTotal_cart;
//     $(".asd").text(rrr);
//     if (subTotal_cart >= userValue) {
//       result = 100;
//       $(".custom-bar-text-fill").show();
//       $(".custom-bar-text-unfill").hide();
//     } else {
//       $(".custom-bar-text-fill").hide();
//       $(".custom-bar-text-unfill").show();
//       $(".custom-bar-text-unfill span").hide();
//       $(".asd").show();
//     }
//     if (ic <= 0) {
//       result = 0;
//       $(".custom-bar-text-fill").hide();
//     }
//      if (cartData.item_count > 0) {
//       $(".cart-quantity-2.cart-number").removeClass("icon-hide"); 
//     } else {
//       $(".cart-quantity-2.cart-number").addClass("icon-hide");
//     }
//     $(".custom-bar-range").css("width", "" + result + "%");
//     parentToChild(cartData)
//     enableBundleFeature && cart_item_count(cartData)
//     enableBundleFeature && slabHandle(cartData);
//   }
// }

// /***** Trigger cart display check ******/
// function triggerCartDisplayCheck(cart_item_count) {
//   var cartLength = $(".w-commerce-commercecartform").find(".mini-cart-list").find("li").length;
//   if (cartLength || cart_item_count) {
//     $(".w-commerce-commercecartform").css({ display: "flex" });
//     $(".w-commerce-commercecartemptystate").css({ display: "none" });
//   } else {
//     $(".w-commerce-commercecartform").css({ display: "none" });
//     $(".w-commerce-commercecartemptystate").css({ display: "flex" });
//   }
// }

/**** Main Logic to  add event handler and other minute items ****/
$(document).ready(function () {
  /*** Focus on the input field inside the form on click of search button ****/
  $(".search_header").click(function () {
     setHeaderPromoHeight();
    $(this).closest("form").find("#input_search_header").focus();
    $("#gl-d-searchbox-input").attr("required", "required");
  });
});

// $(".faq-circle").click(function () {
//   $(this).toggleClass("active");
//   var faqContent = $(this).parent().next(".faq-content");
//   $(".faq-content").not(faqContent).slideUp();
//   faqContent.slideToggle();
//   $(".faq-circle").not(this).removeClass("active");
// });
// $(".faq").click(function () {

//   var content = $(this).next(".faq-content");

//   if(content.is(":visible")){
//     content.slideUp();
//     $(this).removeClass("active");
//   } else {
//     $(".faq-content").slideUp();
//     $(".faq").removeClass("active");

//     content.slideDown();
//     $(this).addClass("active");
//   }

// });

$(".faq").click(function () {

  var content = $(this).next(".faq-content");
  var circle = $(this).find(".faq-circle");

  if(content.is(":visible")){
    content.slideUp();
    $(this).removeClass("active");
    circle.removeClass("active");
  } else {
    $(".faq-content").slideUp();
    $(".faq").removeClass("active");
    $(".faq-circle").removeClass("active");

    content.slideDown();
    $(this).addClass("active");
    circle.addClass("active");
  }

});

$(".collection-banner.about-us").closest(".c_main").addClass("sectiong-top-head-padding");

// click on the first link
$(".wrapper-text-nav-tc a[href='#overview']").click(function () {
  $("html, body").animate(
    {
      scrollTop: $("#overview").offset().top - $(".header").outerHeight(),
    },
    1000
  );
});

// click on the second link
$(".wrapper-text-nav-tc a[href='#product-use']").click(function () {
  $("html, body").animate(
    {
      scrollTop: $("#product-use").offset().top - $(".header").outerHeight(),
    },
    1000
  );
});

// click on the third link
$(".wrapper-text-nav-tc a[href='#disclaimer']").click(function () {
  $("html, body").animate(
    {
      scrollTop: $("#disclaimer").offset().top - $(".header").outerHeight(),
    },
    1000
  );
});

/**** Code related with Cart-related functionalities ****/
// $(document).ready(function () {
//   $(".cs_checkout_btn").click(function (event) {
//     event.preventDefault();
//     $(this).children().html("Checker ud…");
//     setTimeout(function () {
//       $(this).children().html("Säker utcheckning");
//     }, 15000);
//     jQuery.getJSON("/cart.js?cs_checkout_btn", function (cart) {
//       //console.log(cart);
//       if (cart.total_price < 1) {
//         Shopify.clear();
//         $(".mini-cart-list li").remove();
//         $(this).children().html("Säker utcheckning");
//         $(".w-commerce-commercecartform .price-cart").html("$0.00");
//         $(".w-commerce-commercecartform").addClass("udesly-display-none");
//         $(".w-commerce-commercecartemptystate").show();
//         $(".cart-quantity-2").html("0");
//         $(".cart---copy-this").remove();
//       } else {
//         window.location.href = "/checkout/";
//       }
//     });
//   });
// });

// $(".original .c_drawer-fc").slick({
//   dots: false,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 2,
//   slidesToScroll: 1,
//   arrows: false,
//   responsive: [
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 1.2,
//         slidesToScroll: 1,
//       },
//     },
//   ],
// });
last_border();
var ind;
$(document).click(function () {
  ind = 0;
});
ind = 0;

/****
 * Code to update the miniCartTemplate
 */
window.udeslyMiniCartTemplate = function (item, refreshCart = false, dataindex, cartData) {
  var lineItemLength = item.line ? item.line : dataindex;

  /*** Updates the Slick slider inside the cart ***/
  $(".original .c_drawer-fc").slick("refresh");

  /*** Adds classes in the cart ****/
  last_border();

  /*** Fetch mini cart *****/
  if (refreshCart) {
    cartBar(cartData);
  }
  if (enableBundleFeature) {
    var excluded_variant_ids = [p1_v, p2_v, p3_v, p4_v, p5_v, p6_v, p7_v, p8_v, p9_v, p10_v, p11_v, p12_v, p13_v, p14_v, p15_v];
    var surprise_products = excluded_variant_ids.includes(item.variant_id);
  }
  if (enableBundleFeature && surprise_products === true) {
    return `<li class="test2 mini-cart-list-item" data-item-id="${item.id}" style="display:none;"><div class="product-row"><div class="mini-cart-left-block">
    <div dimension="master" class="mini-cart-image" style="background-image: url(${item.image})"></div><div class="product-info-wrapper-2 mini-cart-info-wrapper">
    <a href="#" class="product-title-cart">${item.product_title}</a>${item.variant_title ? ` <div class="text-block-vart">${item.variant_title}</div>` : ""}</div></div></div></li>`;
  } else if (item.properties) {
    let discount_title = ''
    if (item.line_level_discount_allocations[0]) {
      discount_title = item.line_level_discount_allocations[0].discount_application.title
    }
    return `<li class="miniCartUp ${item.product_title} mini-cart-list-item${
      item.properties._kittt == "true" ? ` mini-cart-kit` : ""
    } ${
      item.properties._addon == "true" ? ` mini-cart--addon-line` :  `mini-cart-kit-prev`
    }" data-line="${lineItemLength}" data-item-id="${item.id}"  >
<div class="product-row">
<div class="mini-cart-left-block">
<div dimension="master" class="mini-cart-image" style="background-image: url(${
      item.image
    })"></div>
<div class="product-info-wrapper-2 mini-cart-info-wrapper">
<a href="#" class="product-title-cart">${item.product_title}${
      item.properties._addon == "true"
        ? `<small> - (inkluderet i kit)</small>`
        : ""
    }</a>
${item.variant_title  ? ` <div class="text-block-vart">${item.variant_title}</div>` : "" }    
<h2 class="c_drawer-price" ${item.properties._addon == "true" ? ` style="display:none;"` : ""}><s clss="c_drawer-item-old-price"${item.line_level_total_discount == 0 ? ` style="display:none;"` : ""}>${(item.original_line_price / 100).toFixed(2).slice(0, -3) + " kr"}</s>${(item.final_line_price / 100).toFixed(2).slice(0, -3) + " kr"}</h2>
<p class="c_drawer-item-dicount"${item.line_level_total_discount == 0 ? ` style="display:none;"` : ""}>
    <svg class="icon icon-discount" viewBox="0 0 12 12"><path fill="currentColor" fill-rule="evenodd" d="M7 0h3a2 2 0 0 1 2 2v3a1 1 0 0 1-.3.7l-6 6a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 0-1.4l6-6A1 1 0 0 1 7 0m2 2a1 1 0 1 0 2 0 1 1 0 0 0-2 0" clip-rule="evenodd"/></svg>
     ${discount_title}</p>
            </div>
            </div>
<div class="div-block-140">

 ${
   item.properties._addon == "true"
     ? ""
     : `
  <div class="c_drawer-rmv-main">
     <a href="${
         item.properties._kittt == "true" ? `#` : `#`
       }" class="remove-product-link w-inline-block" udy-el="remove-item"${
         item.properties._kittt == "true"
           ? ` onclick="removeKit(this,[${kitOrAddon(
               item
             )}])" test2="test2" item-time="${item.properties._time}" data-line="${lineItemLength}" data-qt="${item.quantity}"`
           : `onclick="removeaddonests(this,[${item.id}])" data-line="${item.id}" test1="test1" item-time="${item.properties._time}" data-qt="${item.quantity}"`
       }></a>
  </div>`
 }

<div class="price-wrapper"${
      item.properties._addon == "true" ? ` style="display:none;"` : ""
    }>
<div class="wrapperplus"${
      item.properties._kittt == "true" ? ` style="display:none;"` : ""
    }>
<div class="wrapperplus-a">
<a href="#" class="quantity-plus c_drawer-minus" udy-el="qquantity-minus">-</a>
<input class="udesly-fake-number-input quantity-input" type="number" name="uupdates[${
      item.id
    }]" id="uupdates_${item.id}" data-line="${lineItemLength}" min="1" value="${
      item.quantity
    }">
<a href="#" class="quantity-plus c_drawer-plus" udy-el="qquantity-plus">+</a>
            </div>
            </div>
<span class="c_drawer-qty">${
      item.properties._kittt == "true" ? `x${item.quantity}` : ""
    }</span>
            </div>
          

            </div>
            </div>
            </li>`;
  } else {
    return `<li class="test2 mini-cart-list-item ${
      item.product_title
    }" data-line="${lineItemLength}" data-item-id="${item.id}">
<div class="product-row">
<div class="mini-cart-left-block">
<div dimension="master" class="mini-cart-image" style="background-image: url(${
      item.image
    })"></div>
<div class="product-info-wrapper-2 mini-cart-info-wrapper">
<a href="#" class="product-title-cart">${item.product_title}</a>
${item.variant_title  ? ` <div class="text-block-vart">${item.variant_title}</div>` : "" }  
<h2 class="c_drawer-price">${(item.final_price / 100).toFixed(2).slice(0, -3) + " kr"}</h2>
            </div>
            </div>
<div class="div-block-140">

<div class="c_drawer-rmv-main">
               <a href="#"  class="remove-product-link w-inline-block" onclick="removeKit(this,[${
                 item.id
               }])" udy-el="remove-item" data-line="${lineItemLength}" data-qt="${
      item.quantity
    }"></a>
                            </div>
                            
<div class="price-wrapper">
<div class="wrapperplus">
<div class="wrapperplus-a">
<a href="#" class="quantity-plus c_drawer-minus" udy-el="quantity-minus">-</a>
<input class="udesly-fake-number-input quantity-input" type="number" name="updates[${
      item.id
    }]" id="updates_${item.id}" data-line="${lineItemLength}" min="1" value="${
      item.quantity
    }">
<a href="#" class="quantity-plus c_drawer-plus" udy-el="qquantity-plus">+</a>
            </div>
            </div>
            </div>
         
            </div>
            </div>
            </li>`;
  }
};

/*** end min cart template update ***/
$(".text-info-bar-mainn").slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  adaptiveHeight: true,
  autoplay: true,
  autoplaySpeed: 3000,
  vertical: true,
  verticalSwiping: true,
});

$(document).ready(function () {
  /*** Remove : Code for on click event listener on remove button ****/
  $(document).on("click", ".c_drawer-menu", function () {
    $(this).next(".c_drawer-rmv").toggle();
    $(this).toggleClass("c_drawer-menu-click");
  });

  /*** Discount : Code for on click event listener discount on mini cart ***/
  $(document).on("click", ".c_drawer-bottom-dsc h2", function () {
    $(this).next(".c_drawer-bottom-dsc-input").show();
    $(this).hide();
  });

  // $(".original .c_drawer-fc").slick("refresh");
  // cartBar(0);
  // $(document).on("click", "a.w-commerce-commercecartopenlink.button.cc-cart.w-inline-block, .add-to-cart.stickhere .wrapper-cart .add-to-cart-button", function () {
  //   $.getJSON("/cart.js?cardrawer", function (result) {
  //     parentToChild(result)
  //     childToParent(result)
  //     var ind = 0;
  //     $(".mini-cart-list").empty();

  //     let cartitemcount = 0;
  //     $.each(result.items, function (ind, b) {
  //       cartitemcount++;
  //       $(".mini-cart-list").append(window.udeslyMiniCartTemplate(b, true, cartitemcount, result));
  //     });
  //     cartitemcount = 0;
  //     enableBundleFeature && slabHandle(result);
  //   });
  //   $(".original .c_drawer-fc").slick("refresh");
  // });

  // /* Custom Colour page add to cart */
  // $(document).on("click", ".spf-product__form-btn-addtocart", function (e) {
  //   e.preventDefault();
  //   var c_class = $(this);
  //   var c_id = $(this).attr("data-id");
  //   var c_qty = parseInt($(this).attr("data-qty"));
  //   $(this).find('span').text('TILFØJER TIL KURV…');    
  //   variant(c_id, c_qty, c_class, openCart = true);
  // });

  // $(document).on("click", ".block-add-to-bag", function () {
  //   setTimeout(function () {
  //     cartBar(0);
  //   }, 1000);
  // });

  // $(document).on("click", ".cs-atc-btn", function () {
  //   setTimeout(function () {
  //     cartBar(0);
  //   }, 2000);
  // });

  // $(document).on("click",".c_drawer-fc-content button:not(.cs-preshape-v-popup)",function() {
  //   var c_class = $(this);
  //   const buttonDefaultText = c_class.text()?.trim();

  //   $(c_class).css({"background-color": "#4e2e68", "color": "#ffffff"});
  //   $(c_class).text("TILFØJER TIL KURV…");
    
  //   var c_id = $(this).attr("data-id");
  //   var c_qty = parseInt($(this).attr("data-qty"));
  //   variant(c_id, c_qty, c_class, true);

  //   setTimeout(function () {
  //     $(c_class).css({"background-color": "", "color": ""});
  //     $(c_class).text(buttonDefaultText);
  //   }, 1000);
  // });

  // function variant(c_id, c_qty, c_class, openCartDrawer) {
  //   $.ajax({
  //     type: "POST",
  //     url: "/cart/add.js",
  //     dataType: "json",
  //     data: {
  //       quantity: c_qty,
  //       id: c_id,
  //     },
  //     beforeSend: function () {
  //       // c_class.children(".c_drawer-fc-loader-main").css("opacity", "1");
  //     },
  //     success: function (rst) {
  //       updateBundleAnnouncementBar();
  //       if(openCartDrawer) {
  //         document.body.dispatchEvent(new CustomEvent("product-added-to-cart"));
  //         document.body.dispatchEvent(new CustomEvent("cart-should-be-updated"));
  //         if(c_class.attr('data-available')){
  //           c_class.find('span').text(c_class.attr('data-available'));
  //         }
  //       }
  //       $.getJSON("/cart.js?variant_funcation_0000", function (result) {
  //         var ind = 0;
  //         $(".mini-cart-list").empty();
  //         let cartitemcount = 0;
  //         $.each(result.items, function (a, b) {
  //           cartitemcount++;
  //           $(".mini-cart-list").append(window.udeslyMiniCartTemplate(b, true, cartitemcount, result));
  //         });
  //         cartitemcount = 0;
  //       });
  //     },
  //     error: function (err) {
  //       let error = JSON.parse(err.responseText);
  //       console.log("error", error.description);
  //       c_class
  //         .parents(".c_drawer-fc-content")
  //         .append(`<p class="c_drawer-fc-error">${error.description}</p>`);
  //       setTimeout(function () {
  //         c_class
  //           .parents(".c_drawer-fc-content")
  //           .find(".c_drawer-fc-error")
  //           .remove();
  //       }, 2000);
  //       console.log("Error");
  //     },
  //     complete: function (cart) {
  //       //c_class.children(".c_drawer-fc-loader-main").css("opacity", "0");
  //       setTimeout(function () {
  //         jQuery.getJSON("/cart.js?variant_funcation_11111", function (cart) {
  //           $(".c_drawer-summry-main .price-cart").text(
  //             (cart.total_price / 100) + "kr"
  //           );
  //           $(".c_drawer-bottom-total .price-cart").text(
  //               (cart.total_price / 100) + "kr"
  //           );
  //           if(cart.total_discount > 0) {
  //             $(".c_drawer-original-total--price").html((cart.original_total_price / 100).toFixed(2).slice(0, -3) + " kr").css({ display: "block" });  
  //           } else {
  //             $(".c_drawer-original-total--price").css({ display: "none" });  
  //           }
  //         });
  //       }, 1000);
  //     },
  //   });
  // }

  // /***
  //  * Mini Drawer on plus click quantity update
  //  */
  // $(document).on("click", ".c_drawer-plus", function (e) {
  //   var elThis = $(this);
  //   var oldVal = elThis.closest(".wrapperplus-a").find(".quantity-input").val();
  //   var newVal = parseInt(oldVal) + 1;
  //   var tc = $(".cart-quantity-2").text();
  //   var vid = elThis.closest(".mini-cart-list-item").attr("data-item-id");
  //   var line = elThis.closest(".mini-cart-list-item").attr("data-line");

  //   $.post("/cart/change.js?c_drawer-plus", { id: vid, quantity: newVal, }, function (cart) {
  //     var cartt = JSON.parse(cart);
  //     // enableBundleFeature && slabHandle(cartt);
  //     updateBundleAnnouncementBar();
  //     document.body.dispatchEvent(new CustomEvent("cart-should-be-updated"));
     
  //      if (cartt.item_count > 0) {
  //       $(".cart-quantity-2.cart-number").removeClass("icon-hide"); 
  //     } else {
  //       $(".cart-quantity-2.cart-number").addClass("icon-hide");
  //     }
  //     $(".price-cart").html((cartt.total_price / 100).toFixed(2).slice(0, -3) + " kr");
  //     if(cartt.total_discount > 0) {
  //       $(".c_drawer-original-total--price").html((cartt.original_total_price / 100).toFixed(2).slice(0, -3) + " kr").css({ display: "block" });  
  //     } else {
  //       $(".c_drawer-original-total--price").css({ display: "none" });  
  //     }
  //     cartBar(cartt);
  //     if (tc != cartt.item_count) {
  //       elThis.closest(".wrapperplus-a").find(".quantity-input").attr("value", newVal);
  //     }
  //   }
  //   );
  // });

  // /***
  //  * Mini Drawer on minus click quantity update
  //  */
  // $(document).on("click", ".c_drawer-minus", function (e) {
  //   var elThis = $(this);
  //   var oldVal = elThis.closest(".wrapperplus-a").find(".quantity-input").val();
  //   if (oldVal > 1) {
  //     var newVal = parseInt(oldVal) - 1;
  //     var vid = elThis.closest(".mini-cart-list-item").attr("data-item-id");
  //     var line = elThis.closest(".mini-cart-list-item").attr("data-line");
  //     var tc = $(".cart-quantity-2").text();
  //     var vidObj = {
  //       id: vid,
  //       quantity: newVal,
  //     };

  //     $.post("/cart/change.js?c_drawer-minus", vidObj, function (cart) {
  //       var cartt = JSON.parse(cart);
  //       // enableBundleFeature && slabHandle(cartt);
  //        if (cartt.item_count > 0) {
  //            $(".cart-quantity-2.cart-number").removeClass("icon-hide"); 
  //         } else {
  //            $(".cart-quantity-2.cart-number").addClass("icon-hide");
  //         }
  //       updateBundleAnnouncementBar();
  //       document.body.dispatchEvent(new CustomEvent("cart-should-be-updated"));
  //       $(".price-cart").html((cartt.total_price / 100).toFixed(2).slice(0, -3) + " kr");
  //       if(cartt.total_discount > 0) {
  //         $(".c_drawer-original-total--price").html((cartt.original_total_price / 100).toFixed(2).slice(0, -3) + " kr").css({ display: "block" });  
  //       } else {
  //         $(".c_drawer-original-total--price").css({ display: "none" });  
  //       }
  //       cartBar(cartt);
  //       if (tc != cartt.item_count) {
  //         elThis.closest(".wrapperplus-a").find(".quantity-input").attr("value", newVal);
  //       }
  //     });
  //   }
  // });

  // $(document).on("click", ".remove-product-link", function () {
  //   $.getJSON("/cart.js?remove-product-link", function (cart) {
  //     $(".price-cart").html((cart.total_price / 100).toFixed(2).slice(0, -3) + " kr");
  //     if (cart.item_count > 0) {
  //          $(".cart-quantity-2.cart-number").removeClass("icon-hide"); 
  //       } else {
  //          $(".cart-quantity-2.cart-number").addClass("icon-hide");
  //       }
  //   });
  //   $(this).parent().addClass("loading");
  // });

  // document.body.addEventListener('product-added-to-cart', function(event) {
  //   // console.log("Product event:: ", event);
  //   if ($('.c_drawer-original-total--price').length > 0) {
  //     $('.c_drawer-original-price').load(location.href + ' .c_drawer-original-total--price');
  //   }            
  //   updateBundleAnnouncementBar('product-added-to-cart');
  // });

  // document.body.addEventListener('cart-should-be-updated', function(event) {
  //   // console.log("Cart Updated event:: ", event);
  //   updateBundleAnnouncementBar("cart-should-be-updated");
  // });

  function updateBundleAnnouncementBar(event) {
      if ($('.bundle-announcement-bar').length > 0) {
          // console.log("========== Updated bundle announcement bar in "+ event +" ===============");
          $('.bundle-announcement-bar').load(location.href + ' #bundle-announcement-bar');
      }
  }
  
  /***
   * Coupon discount input
   */
  $(document).on("change keyup paste", ".c_drawer-bottom-dsc-input-a input", function () {
    $(this).closest(".c_drawer-bottom-dsc-input-a").find("a").attr("href", "/checkout?discount=" + $(this).val());
    $(".c_drawer-bottom-dsc-input-a input").val($(this).val());
  });
});

/* Remove gift price from cart drawer */
// $(document).ready(function () {
//   $(".li.mini-cart-list-item.Free.Gift .price-wrapper").remove();
//   setTimeout(function () {
//     jQuery.getJSON("/cart.js?onload_call", function (cart) {
//       if(cart.total_discount > 0) return;
//       if (cart.total_price < 1 && cart.item_count > 0) {
//         $.ajax({
//           type: "POST",
//           url: "/cart/clear.js",
//           success: function () {
//             console.log("You cleared the cart!");
//           },
//           dataType: "json",
//         });
//       }
//     });
//   }, 2000);
// });

/* Product image for mobile */
$("body:not(.kit-v2) .kit-pro-thumb:not(.pro-images)").slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1.2,
  slidesToScroll: 1,
  arrows: false,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1.2,
        slidesToScroll: 1,
      },
    },
  ],
});

/*Scroll Up/Down add class */
var lastScrollTop = 0;
$(window).scroll(function (event) {
  var st = $(this).scrollTop();
  if (st > lastScrollTop) {
    $("body").addClass("scrolling_down");
    $("body").removeClass("scrolling_up");
  } else {
    $("body").addClass("scrolling_up");
    $("body").removeClass("scrolling_down");
  }
  lastScrollTop = st;
});

$(window).scroll(function (event) {
  var scroll = $(window).scrollTop();
  const el = $(".colors-final-list-sel");
  $("#sticky-container").toggleClass("stickhere", scroll >= el?.offset()?.top);
  const el1 = $("#csWrapperCart");
  $("#sticky-containers").toggleClass("stickhere", scroll >= el1?.offset()?.top);
});

$(window).scroll();

function sticky_relocate() {
  var window_top = $(window).scrollTop();
  var footer_top = $("#c-footer").offset().top;
  var div_height = $("#sticky-container").height() + 800;
  if (window_top + div_height > footer_top) {
    $("#sticky-container").addClass("u-hidden");
  } else {
    $("#sticky-container").removeClass("u-hidden");
  }
  var div_heights = $("#sticky-containers").height() + 800;
  if (window_top + div_heights > footer_top) {
    $("#sticky-containers").addClass("u-hidden");
  } else {
    $("#sticky-containers").removeClass("u-hidden");
  }
}

$(function () {
  $(window).scroll(sticky_relocate);
  sticky_relocate();
});

$(document).ready(function(){
  if ($('.custom-aattcc[disabled]').length > 0) {
   setTimeout(function(){
      $('.custom-aattcc2').val('Vælg farver');
    },400);
  }

   //STOCK URGENCY START
      var stock = parseInt($("#variant-stock").html());
      var maxqty = parseInt($(".selected-variant").data("quantity"));
      if(stock == '' || stock <= 0) {
        $(".progress-content").addClass('hidden');
      } 
   //STOCK URGENCY END
  
});
      
/* Script added by speed optimization team */
var script_loaded = !1;
function loadJSscripts() {
  script_loaded ||
    (void 0 !== observer && observer.disconnect(),
    void 0 !== window.yett && window.yett.unblock(),
    (script_loaded = !0),
    document
      .querySelectorAll("iframe[data-src], script[data-src], img[data-src]")
      .forEach((e) => {
        (datasrc = e.dataset.src), null != datasrc && (e.src = datasrc);
      }),
    document.querySelectorAll("link[data-href]").forEach((e) => {
      (datahref = e.dataset.href), null != datahref && (e.href = datahref);
    }),
    document.querySelectorAll("script[type='text/lazyload']").forEach((e) => {
      var t = document.createElement("script");
      for (a = 0; a < e.attributes.length; a++) {
        var r = e.attributes[a];
        t.setAttribute(r.name, r.value);
      }
      (t.type = "text/javascript"),
        (t.innerHTML = e.innerHTML),
        e.parentNode.insertBefore(t, e),
        e.parentNode.removeChild(e);
    }),
    document.dispatchEvent(new CustomEvent("asyncLazyLoad")));
}
var activityEvents = [
  "mousedown",
  "mousemove",
  "keydown",
  "scroll",
  "touchstart",
  "click",
  "keypress",
  "touchmove",
];
activityEvents.forEach(function (e) {
  window.addEventListener(e, loadJSscripts, !1);
});






 $(document).on("click","[data-toggle='collapse']",function() {
    var parent = $(this).data("parent");
   
    var target = $(this).data("href");
    
    if($(parent).length && $(parent).hasClass('panel-group')) {
     $(parent+" .panel").each(function() {
       var p = $(this).find("[data-toggle='collapse']");
       var t = p.data("href");
       if(t!= target && p.attr("aria-expanded") == "true") {
        $(t).slideUp().removeClass("in");
         $(this).find(".faq-icon").removeClass("active");
        p.addClass("collapsed").attr("aria-expanded","false");
       } 
     });
    } 
    if($(this).attr("aria-expanded") == "false") {
      $(target).slideDown().addClass("in");
      $(this).find(".faq-icon").addClass("active");
      $(this).removeClass("collapsed").attr("aria-expanded","true");
    } else {
      $(target).slideUp().removeClass("in");
      $(this).find(".faq-icon").removeClass("active");
      $(this).addClass("collapsed").attr("aria-expanded","false");
    }
  });

// kits megamenu hide and show js
const hoverable = document.querySelector('.menu-name-kits');
const targetDiv = document.querySelector('.kits-megamenu');

// Add event listener for mouseenter
hoverable.addEventListener('mouseenter', function() {
    targetDiv.classList.add("active");
});

// Add event listener for mouseleave
hoverable.addEventListener('mouseleave', function() {
  // targetDiv.style.display = 'none';
  targetDiv.classList.remove("active");
});

// if(document.querySelector(".video-btn") !== null) {
//   document.querySelector('.video-btn .btn-text').addEventListener('click', function() {
//     document.querySelector('.mobile-popup-video').style.display = 'block';
//   });
// }
// if(document.querySelector(".mobile-popup-video") !== null) {
//   window.addEventListener('click', function(event) {
//     var popup = document.querySelector('.mobile-popup-video');
//     if (event.target == popup) {
//       popup.style.display = 'none';
//     }
//   });
// }

var popup = document.querySelector('.mobile-popup-video');
var iframe = document.getElementById("ytPlayer");

if(document.querySelector(".video-btn") !== null) {
  document.querySelector('.video-btn .btn-text').addEventListener('click', function() {
      document.querySelector('.mobile-popup-video').style.display = 'block';
  });
  }
if(popup){
  popup.addEventListener("click", (e) => {
    if (!e.target.closest(".popup-content")) {
      // console.log("testtttttt------")
      stopYouTubeVideo();
      popup.style.display = 'none';
    }
  });
}
  // Function to stop video
  function stopYouTubeVideo() {
    if (iframe && iframe.contentWindow) {
      // console.log("test====")
      iframe.contentWindow.postMessage(
        JSON.stringify({
          event: "command",
          func: "stopVideo",
          args: ""
        }),
        "*"
      );
    }
  }

 var video = document.querySelector('.desktop-video');
  if (video) {
    video.pause();
    video.currentTime = 0;
    video.muted = false;

    // IntersectionObserver for scroll-based pause
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(entry => {
          // Only pause/reset if video was playing and scrolled out
          if (!entry.isIntersecting && !video.paused) {
            video.pause();
            video.currentTime = 0;
          }
        });
      },
      {
        threshold: 0.5 // Trigger when less than 50% visible
      }
    );

    observer.observe(video);
  }
/* ======================== Quickview popup JS ======================== */
$(document).on("click", ".cs-preshape-v-popup", function (e) {
  e.preventDefault();
  $('body').addClass('show-quickview');
  p_Handle = $(this).data("handle");
  var product_url = `${location.origin}/products/${p_Handle}?view=quickview_data`;
  $.ajax({
    url: product_url,
    type: "GET",
    success: function (quickview_data) {
      $("body").addClass("overflow-hidden");
      $(".quickview_outer").addClass("quickview_open");
      $(".quickview_overlay").show();
      $(quickview_data).appendTo(".quickview_popup");
      $(".quickview_popup").show();
    },
    error: function (error) {
      console.error("Error fetching product information:", error);
    },
  });
});

$(document).on("click", ".quickview_overlay, .quickview_close", function () {
  closeQuickviewModal();
});

function closeQuickviewModal() {
  $(".quickview_popup").html("");
  $("body").removeClass("overflow-hidden show-quickview");
  $(".quickview_outer").removeClass("quickview_open");
  $(".quickview_overlay").fadeOut();
  $(".quickview_popup").fadeOut();
}
/* ======================== End Quickview popup JS ======================== */

/* ==================== Kit New Landing Page JS ==================== */
/* Product image for mobile */
var slickSlider = $("body:not(.kit-v2) .pro-images");
slickSlider.slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  adaptiveHeight: true,
  asNavFor: '.pro-thumb-images',
  responsive: [
    {
      breakpoint: 790,
      settings: {
        slidesToShow: 1.6,
        slidesToScroll: 1,
      },
    },
  ],
});

$('.kit-product-v3 [data-fancybox="gallery2"], .kit-product-v3 [data-fancybox="mobile gallery"]').fancybox({
  backFocus: false,
  loop: true,
  hash: false,
  touch: true,
  mobile: {
    clickSlide: "close",
    clickOutside: "close",
  },
  clickSlide: "close",
  clickOutside: "close",
  video: {
    autoStart: false,
  },
  beforeClose: function (instance, slide) {
    let video = slide.$content.find("video").get(0);
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  },
  afterClose: function(instance, current) {
    let lastIndex = instance ? instance.currIndex : 0;
    $('.thumb-item[data-slick-index="'+lastIndex+'"]').click();
  }
});

$('.pro-thumb-images').slick({
  slidesToShow: 8,
  slidesToScroll: 1,
  infinite: false,
  asNavFor: '.pro-images',
  arrows: true,
  prevArrow: '<button type="button" class="custom-arrow arrow-prev"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M1.5 11.9813L2.83125 13.3125L9 7.14375L15.1688 13.3125L16.5 11.9812L9 4.48125L1.5 11.9813Z" fill="#4e2e68"/></svg></button>',
  nextArrow: '<button type="button" class="custom-arrow arrow-next"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M1.5 6.01875L2.83125 4.6875L9 10.8563L15.1688 4.6875L16.5 6.01875L9 13.5188L1.5 6.01875Z" fill="#4e2e68"/></svg></button>',
  vertical: true,
  verticalSwiping: true,
  focusOnSelect: true,
  responsive: [
      {
        breakpoint: 790,
        settings: {
          vertical: false,
          verticalSwiping: false,
          arrows: false,
        }
      }
    ]
});
if($('.image-with-text-slider').length > 0) {
  $('.image-with-text-slider').slick({
    autoplay: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow: $('.desktop-custom-slick-prev'),
    nextArrow: $('.desktop-custom-slick-next'),
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 790,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          prevArrow: $('.custom-arrow-wrapper .custom-slick-prev'),
          nextArrow: $('.custom-slick-next')
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow: $('.custom-slick-prev'),
          nextArrow: $('.custom-slick-next')
        }
      }
    ]
  });
}
if ($('.video-container .video-wrapper').length > 0) {
  // $('.video-container .video-wrapper .custom-play-button').on('click', function () {
  //   console.log("Video button click event");
  //   const $videoContainer = $(this).closest('.video-container');
  //   if ($videoContainer.hasClass('slick-center')) {
  //     console.log("Check the slick-center Class");
  //     $videoContainer.find('.video-wrapper').addClass('active');
  //     const $video = $videoContainer.find('video');
  //     if ($video.length > 0 && $video.prop('paused')) {
  //       $video.prop('muted', false);
  //       $video.get(0).play();
  //     }
  //   }
  // });
  $('.video-container .video-wrapper .custom-play-button').on('click', function () {
    // console.log("Video button click event");
    const $videoContainer = $(this).closest('.video-container');
    let $deferredContainer = $(this).closest('.video-wrapper');
    if (!$deferredContainer.attr('loaded')) {
      $videoContainer.find('.video-wrapper').addClass('active');
      let $template = $deferredContainer.find('template');
      if (!$template.length) return;
      let content = $('<div>').append($template.html());
      $deferredContainer.attr('loaded', true);
      let $deferredElement = $deferredContainer.append(content.find('video, model-viewer, iframe').first());
      $deferredElement.trigger('focus');
      if ($deferredElement.is('video') && $deferredElement.attr('autoplay')) {
        $deferredElement[0].play();
      }
    }
  });
}

if ($(".comparison-section .tab-item").length > 0 ) {
  $(".comparison-section .tab-item").on("click", function () {
    $(".comparison-section .tab-item").removeClass("active");
    $(".comparison-section .tab-content").removeClass("active");
  
    $(this).addClass("active");
    $("#tab-" + $(this).data("tab")).addClass("active");
  });
}
$(".custom-review-product-summary").on("click", function () {
  let targetSelector = $(this).attr("data-scroll-target");
  let targetElement = $(targetSelector);

  if (targetElement.length) {
    $("html, body").animate({
      scrollTop: targetElement.offset().top - 150
    }, 800);
  }
});

document.querySelectorAll(".tooltip-wrapper").forEach((icon) => {
  let tooltip = icon.querySelector(".tooltip-box");
  let tooltipIcon = icon.querySelector(".tooltip-icon");
  let closeBtn = icon.querySelector(".close-tooltip");

  if (!tooltip) return; // Skip if no tooltip exists

  icon.addEventListener("mouseenter", function () {
    let rect = tooltipIcon.getBoundingClientRect();
    let tooltipRect = tooltip.getBoundingClientRect();

    tooltip.style.position = "fixed";
    tooltip.style.left = `${Math.min(rect.left + rect.width / 2)}px`;
    tooltip.style.top = `${Math.max(rect.top - tooltipRect.height - 5, 10)}px`;
    tooltip.style.visibility = "visible";
    tooltip.style.opacity = "1";
  });

  icon.addEventListener("mouseleave", hideTooltip);
  if (closeBtn) closeBtn.addEventListener("mouseenter", hideTooltip);

  function hideTooltip() {
    // alert("Hidden Tooltip:::");
    tooltip.style.visibility = "hidden";
    tooltip.style.opacity = "0";
    tooltip.style.left = "auto";
    tooltip.style.top = "auto";
  }
});
/* ==================== End Kit New Landing Page JS ==================== */
// ============== sticky bar increase product quantity according to price ==============

 $(document).on("change", ".Qty_btn", function (e) {
  var $input = $(this);
  var quantity = parseInt($input.val(), 10);
  var unitPrice = parseFloat($input.attr('data-price')); 
  var totalPrice = unitPrice * quantity;
  var moneyFormat = $('html').attr('data-money-format');
  var formattedPrice = Shopify.formatMoney(totalPrice, moneyFormat); 
    $input.closest('.wrapper-add-to-cart').find('.pricing-package').text(formattedPrice); 

  });
// ============== END sticky bar increase product quantity according to price ==============
function setHeaderPromoHeight() {
  if ($('.header').length) {
    let height = $('.header').outerHeight();
    $('body').css('--header-height', height + 'px');
  }
}
 setHeaderPromoHeight();